import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { emptyProps, withFieldGroup } from '../hooks/use-app-form.js';
export const FlightLegFormGroup = withFieldGroup({
    defaultValues: {},
    props: emptyProps(),
    render: function Render({ errorsDisplayType = 'bellow', group }) {
        return (_jsxs("div", { className: "grid grid-cols-1 gap-3 md:grid-cols-2", children: [_jsx(group.AppField, { name: "departure", children: (field) => (_jsx(field.AirportAutocompleteField, { errorsDisplayType: errorsDisplayType, label: "Lieu de d\u00E9part", mode: "departure" })) }), _jsx(group.AppField, { name: "destination", children: (field) => (_jsx(field.AirportAutocompleteField, { errorsDisplayType: errorsDisplayType, label: "Destination", mode: "destination" })) })] }));
    },
});
